import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const CartContext = createContext();

export const useCart = () => {
    const context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};

export const CartProvider = ({ children }) => {
    const [cartCount, setCartCount] = useState(0);
    const [loading, setLoading] = useState(true);

    // Fetch cart count on mount
    const fetchCartCount = async () => {
        try {
            const response = await api.get('get/my/trees/', { withCredentials: true });
            const items = response.data || [];
            const totalCount = items.reduce((sum, item) => sum + (item.count || 0), 0);
            setCartCount(totalCount);
        } catch (error) {
            console.error('Failed to fetch cart count:', error);
            setCartCount(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCartCount();
    }, []);

    // Add item to cart
    const addToCart = async (productId, count = 1) => {
        try {
            await api.post('addToCart/', { product_id: productId, count }, { withCredentials: true });
            setCartCount(prev => prev + count);
            return true;
        } catch (error) {
            console.error('Failed to add to cart:', error);
            return false;
        }
    };

    // Update cart count manually (useful after removing items, etc.)
    const updateCartCount = (newCount) => {
        setCartCount(newCount);
    };

    // Refresh cart count from server
    const refreshCart = () => {
        fetchCartCount();
    };

    const value = {
        cartCount,
        loading,
        addToCart,
        updateCartCount,
        refreshCart
    };

    return (
        <CartContext.Provider value={value}>
            {children}
        </CartContext.Provider>
    );
};